import type { Capability } from '@shared/collaboration/access'

export function hasCapability(
  resource: { capabilities?: Capability[] } | undefined,
  cap: Capability
): boolean {
  return !!resource?.capabilities?.includes(cap)
}
